export const openCountryList = ['AE', 'SA', 'QA', 'RU', 'KY', 'US', 'CN', 'BH', 'EG'];
export const openCountryLowerCaseList = openCountryList.map((ocl) => ocl.toLowerCase());

export * from './base';
export * from './constant';
export * from './domainConfig';
export * from './manufacturersConfig';
